import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ColumnModelItemEntity } from '../../../domain/column-model-item.entity';

export enum ColumnModelFormControls {
	Id = 'id',
	Label = 'label',
	Description = 'description',
}

@Injectable()
export class ColumnModelMetadataForm {
	public form: FormGroup;

	public constructor(protected readonly fb: FormBuilder) {
		this.form = this.fb.group({
			[ColumnModelFormControls.Id]: [
				{
					value: null,
					disabled: true,
				},
			],
			[ColumnModelFormControls.Label]: [
				'',
				[Validators.required, Validators.maxLength(256)],
			],
			[ColumnModelFormControls.Description]: ['', [Validators.maxLength(2500)]],
		});
	}

	public extract(): Partial<ColumnModelItemEntity> {
		const formValues = this.form.value;
		return ColumnModelItemEntity.build({
			id: formValues[ColumnModelFormControls.Id] ?? null,
			label: formValues[ColumnModelFormControls.Label] ?? '',
			description: formValues[ColumnModelFormControls.Description] ?? '',
		});
	}

	public populate(config: Partial<ColumnModelItemEntity> | null): void {
		if (config === null || config.id === undefined) {
			throw new Error('Invalid entity');
		}
		this.form.patchValue({
			[ColumnModelFormControls.Id]: config.id,
			[ColumnModelFormControls.Label]: config?.label ?? '',
			[ColumnModelFormControls.Description]: config?.description ?? '',
		});
	}

	public enable(): void {
		if (this.form.enabled) {
			return;
		}
		const labelControl = this.form.get(ColumnModelFormControls.Label);
		const descriptionControl = this.form.get(
			ColumnModelFormControls.Description
		);
		this.form.enable();

		labelControl?.setValidators([
			Validators.required,
			Validators.maxLength(256),
		]);
		labelControl?.markAsTouched();
		descriptionControl?.setValidators([Validators.maxLength(2500)]);
	}

	public disable(): void {
		if (this.form.disabled) {
			return;
		}
		this.form.reset();
		this.form.disable();
	}
}
